import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MasterCreateProfileService } from './master-create-profile.service';
import { MasterHomeCreateProfileService } from '../../service/master-home-create-profile.service';
import { uniqBy } from 'lodash';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { __await } from 'tslib';

@Component({
  selector: 'app-master-create-profile',
  templateUrl: './master-create-profile.component.html',
  styleUrls: ['./master-create-profile.component.scss'],
})
export class MasterCreateProfileComponent implements OnInit {
  profiles: any;
  roles: any[] = [];
  count: Array<any> = [];
  static total: Array<number>;
  name: string;
  description: string;
  form: any;
  panelOpenState;
  movementPermissions:any
  positionPermissions:any
  otherReportPermissions:any
  hasRelatoriosPermissionSelected: boolean = false;
  reportPermission:any;
  @Output() permissionData: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public serviceHomeCreateProfile: MasterHomeCreateProfileService,
    public serviceCreateProfile: MasterCreateProfileService,
    public alertService: DialogBoxService,
  ) {}

  async  ngOnInit() {
   await this.getProfiles();
   this.preparePermissions()
  }

  onRelatoriosSelectionChanged(isSelected: boolean) {
    this.hasRelatoriosPermissionSelected = isSelected;
    if (!isSelected) {
      // Clear all report permissions
      this.clearAllReportPermissions();
    }
  }
  clearAllReportPermissions() {
    // Helper function to uncheck permissions
    const uncheckPermissions = (permissions) => {
      if (permissions) {
        permissions.forEach(p => p.checked = false);
        this.checkDataTable(permissions); // Update the roles array
      }
    };
  
    // Uncheck all report permissions
    uncheckPermissions(this.movementPermissions);
    uncheckPermissions(this.positionPermissions);
    uncheckPermissions(this.otherReportPermissions);
  
    // Force update the view
    this.movementPermissions = [...this.movementPermissions];
    this.positionPermissions = [...this.positionPermissions];
    this.otherReportPermissions = [...this.otherReportPermissions];
  }
  get totalPermission() {
    return MasterCreateProfileComponent.total;
  }

  async getProfiles() {
    this.profiles = await this.serviceCreateProfile.getProfiles();
  }
  preparePermissions(): void {
    this.movementPermissions = [];
    this.positionPermissions = [];
    this.otherReportPermissions = [];
  
    this.profiles.forEach((profile) => {
      const permissions = profile?.permissions || [];
      if(profile.name=="Relatorios"){
          this.movementPermissions = permissions.filter(p => p.name?.startsWith('MOVEMENT'));
          this.positionPermissions = permissions.filter(p => p.name?.startsWith('POSICAO') || p.name?.startsWith('POSITION'));
          this.otherReportPermissions = permissions.filter(p => p.name?.startsWith('OTHER'));
          if(profile?.name =='Permissões de relatório'){
            this.reportPermission = profile?.permissions?.filter(p => p.name ==='Relatórios');
            }
      }
    
    });
    const desiredOrder = ['Permissões de sistema', 'Permissões de operação', 'Permissões de relatório',"Relatorios"];

    if (this.profiles) {
      this.profiles.sort((a, b) => {
        const indexA = desiredOrder.indexOf(a.name);
        const indexB = desiredOrder.indexOf(b.name);
        return indexA - indexB;
      });
  }
}
  validateCheckedItems(): boolean {
    let isValid : boolean =false 
    const movementsValid = this.movementPermissions?.some(p => p.checked=="true" ||p.checked==true) ?? false;
    const positionsValid = this.positionPermissions?.some(p => p.checked=="true" ||p.checked==true) ?? false;
    const reportsValid = this.otherReportPermissions?.some(p => p.checked=="true" ||p.checked==true) ?? false;
    const reportPermission = this.reportPermission?.some(p => p.checked=="true" ||p.checked==true) ?? false;
    if(!reportPermission || (reportPermission && (movementsValid || positionsValid || reportsValid))){
      isValid =true
    } else{
      isValid=false
    }

    return isValid
  }
  checkDuplicateValues() {
    this.roles = uniqBy(this.roles, 'id');
  }

  checkDataTable(e) {
    // e.map(ele => {
    //   this.roles.push(ele);
    // });
    // Filter out any undefined/null entries
  const validEntries = e.filter(item => item !== null && item !== undefined);
  
  // Add new checked roles or update existing ones
  validEntries.forEach(element => {
    const existingIndex = this.roles.findIndex(r => r.id === element.id);
    if (element.checked) {
      if (existingIndex === -1) {
        this.roles.push(element);
      } else {
        this.roles[existingIndex] = element;
      }
    } else {
      if (existingIndex !== -1) {
        this.roles.splice(existingIndex, 1);
      }
    }
  });
    this.checkDuplicateValues();
    this.countChecked(e);
  }

  countChecked(e) {
    this.count.push(e);
    const count = this.count
      .map(ar => JSON.stringify(ar))
      .filter((itm, idx, arr) => arr.indexOf(itm) === idx)
      .map(str => JSON.parse(str));

    MasterCreateProfileComponent.total = count.map(roles => {
      return roles.filter((role: any) => role.checked == true).length;
    });
  }
  async checkNameProfile() {
    const { name } = this.serviceHomeCreateProfile.form.value;
    const payload = {name: name};
    const checNamePermission = await this.serviceCreateProfile.checkPermissionName(payload);
    const { exists } = checNamePermission;

    // if (exists) {
    //     `O perfil de acesso ${name} já existe. Favor selecionar outro nome`.showWarn()

    // }
  }
  getLength(arr: Array<any>) {
    if (arr !== null && arr !== undefined) {
      return arr.length;
    }
    return 0;
  }
  sumReportsSelected(arr1,arr2,arr3) {
    let combinedReportsArray = [...(arr1 || []), ...(arr2 || []), ...(arr3 || [])];
    let len = combinedReportsArray.length
    let numSelected = 0;
    if (combinedReportsArray !== null) {
      combinedReportsArray.forEach(elemeent => {
        if (JSON.parse(elemeent.checked) === true) {
          numSelected++;
        }
      });
    }
    let str = numSelected + "/"+len
    return str

    
  }
}
